module.exports = __webpack_public_path__ + "img/icon81.abbaa6b5.png";